import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import TextInputCountriesAdd from "../component/textInputCountriesAdd";
import * as ImagePicker from "expo-image-picker";
import {
  authActionRegister,
  authActionPutRegister,
} from "../action/authAction";
import Modal from "modal-react-native-web";
import { useRecoilValue } from "recoil";
import { tokenState } from "../reducer/recoil";
const { width, height } = Dimensions.get("window");
import { styles, stylesResponsive } from "./style/detailCountries";
export default function detailCountries({ onPress, navigation, route }) {
  const [image, setImage] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const token = useRecoilValue(tokenState);
  const [show, setShow] = useState(false);
  const [alerts, setAlert] = useState(false);
  const [validation, setValidation] = useState({
    valid1: false,
    valid2: false,
    valid3: false,
    valid4: false,
    valid5: false,
    valid6: false,
  });
  const [state, setState] = useState({
    username: "",
    password: "123456",
    role: "User",
    email: "",
    sub_email: null,
    country_name: "",
    abbreviation: "",
    image: null,
  });

  useEffect(() => {
    if (route.params != undefined) {
      console.log(route.params);
      setState({
        ...state,
        country_name: route.params.country_name,
        abbreviation: route.params.abbreviation,
        username: route.params.Association[0].User.username,
        image: route.params.image_url,
        email: route.params.Association[0].email,
        sub_email: route.params.Association[0].sub_email,
      });
      if (route.params.Association[0].sub_email != null) {
        setShow((val) => !val);
      }
    }
  }, []);

  async function Register() {
    if (
      state.username.length > 0 &&
      state.email.length > 0 &&
      state.country_name.length > 0 &&
      state.abbreviation.length > 0
    ) {
      if (route.params != undefined) {
        if (state.password != null) {
          if (state.password.length < 6) {
            setAlert(true);
            return;
          }
        }

        let body = {
          ...state,
          sub_email:
            typeof state.sub_email == "object"
              ? state.sub_email
              : state.sub_email.split(","),
          user_id: route.params.Association[0].User.user_id,
        };
        console.log("authActionPutRegister >> ", body);
        const register = await authActionPutRegister({
          state: body,
          token: token.token,
        });
        if (register) {
          setModalVisible(true);
          setTimeout(() => {
            setModalVisible(false);
          }, 2000);
          setTimeout(() => {
            navigation.navigate("Countries");
          }, 3000);
        }
      } else {
        console.log("เข้า");
        if (state.image == null) {
          setValidation((val) => ({ ...val, valid1: true }));
          // return;
        }
        if (state.country_name.length == 0) {
          setValidation((val) => ({ ...val, valid2: true }));
          // return;
        }
        if (state.abbreviation.length == 0) {
          setValidation((val) => ({ ...val, valid3: true }));
          // return;
        }
        if (state.username.length == 0) {
          setValidation((val) => ({ ...val, valid4: true }));
          // return;
        }
        if (state.email.length == 0) {
          setValidation((val) => ({ ...val, valid5: true }));
          // return;
        }
        if (state.password == null) {
          setValidation((val) => ({ ...val, valid6: true }));
          // return;
        }

        if (
          state.password !== null &&
          state.email.length !== 0 &&
          state.username.length !== 0 &&
          state.abbreviation.length !== 0 &&
          state.country_name.length !== 0 &&
          state.image !== null
        ) {
          const register = await authActionRegister({
            ...state,
            sub_email:
              typeof state.sub_email == "object"
                ? state.sub_email
                : state.sub_email.split(","),
          });
          if (register) {
            setModalVisible(true);
            setTimeout(() => {
              setModalVisible(false);
            }, 2000);
            setTimeout(() => {
              navigation.navigate("Countries");
            }, 3000);
          }
        }
      }
    } else {
      if (state.image == null) {
        setValidation((val) => ({ ...val, valid1: true }));
        // return;
      } else {
        setValidation((val) => ({ ...val, valid1: false }));
      }
      if (state.country_name.length == 0) {
        setValidation((val) => ({ ...val, valid2: true }));
        // return;
      } else {
        setValidation((val) => ({ ...val, valid2: false }));
      }
      if (state.abbreviation.length == 0) {
        setValidation((val) => ({ ...val, valid3: true }));
        // return;
      } else {
        setValidation((val) => ({ ...val, valid3: false }));
      }
      if (state.username.length == 0) {
        setValidation((val) => ({ ...val, valid4: true }));
        // return;
      } else {
        setValidation((val) => ({ ...val, valid4: false }));
      }
      if (state.email.length == 0) {
        setValidation((val) => ({ ...val, valid5: true }));
        // return;
      } else {
        setValidation((val) => ({ ...val, valid5: false }));
      }
      if (state.password == null) {
        setValidation((val) => ({ ...val, valid6: true }));
        // return;
      } else {
        setValidation((val) => ({ ...val, valid6: false }));
      }
    }
  }

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });
    console.log(result);
    if (!result.cancelled) {
      setImage(result.uri);
      setState({ ...state, image: result.uri });
    }
  };

  return (
    <View
      style={width >= 1280 ? styles.viewDetail : stylesResponsive.viewDetail}
    >
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <TouchableOpacity style={styles.viewModal}>
          <View style={styles.viewSuccesModal}>
            <Text style={styles.textSuccesModal}>{"SUCCESSFUL"}</Text>
          </View>
        </TouchableOpacity>
      </Modal>
      <Text
        style={[
          width >= 1280 ? styles.textSubject : stylesResponsive.textSubject,
          {
            color: validation.valid1 ? "#ff0000" : "#2B6AB1",
          },
        ]}
      >
        IMAGE
      </Text>

      <View style={styles.viewUpload}>
        <TouchableOpacity onPress={pickImage} style={styles.buttonUpload}>
          <Text style={styles.textUpload}>UPLOAD</Text>
        </TouchableOpacity>
        <Text style={styles.textSelectPhoto}>select your photo</Text>
      </View>
      {state.image != null && (
        <Image
          style={{
            width: width >= 1280 ? 300 : 120,
            height: width >= 1280 ? 80 : 60,
            marginVertical: 10,
          }}
          resizeMode="contain"
          source={{ uri: state.image }}
        />
      )}

      <TextInputCountriesAdd
        defaultValue={state.country_name}
        onChangeText={(text) => setState({ ...state, country_name: text })}
        Subject="NAME"
        style={{
          color: validation.valid2 ? "#ff0000" : "#2B6AB1",
          borderColor: validation.valid2 ? "#ff0000" : "#2B6AB1",
        }}
      />
      <TextInputCountriesAdd
        defaultValue={state.abbreviation}
        onChangeText={(text) => setState({ ...state, abbreviation: text })}
        Subject="ABBREVIATION"
        style={{
          color: validation.valid3 ? "#ff0000" : "#2B6AB1",
          borderColor: validation.valid3 ? "#ff0000" : "#2B6AB1",
        }}
      />
      <TextInputCountriesAdd
        defaultValue={state.username}
        onChangeText={(text) => setState({ ...state, username: text })}
        Subject="USER NAME"
        style={{
          color: validation.valid4 ? "#ff0000" : "#2B6AB1",
          borderColor: validation.valid4 ? "#ff0000" : "#2B6AB1",
        }}
      />
      <TextInputCountriesAdd
        defaultValue={state.email}
        onChangeText={(text) => setState({ ...state, email: text })}
        Subject="E-mail"
        onPress={() => {
          setShow((val) => !val);
        }}
        style={{
          color: validation.valid5 ? "#ff0000" : "#2B6AB1",
          borderColor: validation.valid5 ? "#ff0000" : "#2B6AB1",
        }}
        plus
      />
      {show && (
        <TextInputCountriesAdd
          defaultValue={state.sub_email}
          onChangeText={(text) => setState({ ...state, sub_email: text })}
          Subject=""

          // plus
        />
      )}
      <TouchableOpacity onPress={Register} style={styles.buttonSave}>
        <Text style={styles.textSave}>SAVE</Text>
      </TouchableOpacity>
    </View>
  );
}
